<script>
//TODO: centralize location, time and canteen settings!
import Modal from '@/components/atoms/Modal'
import InputLocation from '@/components/atoms/inputlib/components/InputLocation'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import SpecifyLocation from '@/components/organism/location/SpecifyLocation'
import InputTextarea from '@/components/atoms/inputlib/components/InputTextarea'
import Box from '@/components/atoms/Box'
import { Query } from '@/modules/plugins/query'

import { mapGetters } from 'vuex'
import { Address } from '@/api'
import isEmpty from 'lodash.isempty'

export default {
    name: 'ModalEnterLocation',

    components: {
        Modal,
        ButtonLoader,
        InputLocation,
        SpecifyLocation,
        InputTextarea,
        Box,
    },

    data() {
        return {
            address: {},
            loading: false,
            backup: null,
            callback: null,
            error: null,
            showDetails: false,
        }
    },
    computed: {
        ...mapGetters({
            needToSetQuery: 'site/needToSetQuery',
            orderAddress: 'order/address',
            smDevice: 'smDevice',
        }),
        addressValue: {
            get() {
                return this.address.model
            },
            set(model) {
                this.address.model = model
            },
        },
        hasAddress() {
            return !isEmpty(this.address?.model)
        },
    },
    methods: {
        open(callback, error) {
            this.error = error
            this.address = new Address(this.orderAddress)
            this.showDetails = !!this.address.sub_address
            this.callback = callback
            this.$refs.ModalEnterLocation.openModal()
        },
        close() {
            this.error = null
            this.address = {}
            this.callback = null
            this.$refs.ModalEnterLocation.closeModal()
        },
        verifyDistance() {
            this.$refs.specifyLocation.verifyStep()
        },
        async setAddress() {
            this.$store.dispatch('order/setAddress', this.address.model)
            this.$user.getExpenseRules()
            if (this.needToSetQuery) {
                this.setQuery(Query.getLocationQuery(this.address.model))
            }

            try {
                await this.$cart.calculate()
            } finally {
                if (this.callback) this.callback()
                this.close()
            }
            return
        },
        checkForPremise(address) {
            this.showDetails = !!address.premise
        },
        onLocationDrag(address) {
            this.addressValue.sub_address = address.premise
        },
    },
}
</script>

<template lang="pug">
modal.enter-location(ref="ModalEnterLocation" :closable="false")
    template(v-slot:header)
        .flex.flex-column
            .modal-header-text.text-center.pt-8 {{ $t("maps.enter_your_full_address") }}
            p.text-center.mb-0.text-danger.mt-2(v-if="error") {{ $t(error) }}
    template(v-slot:body)
        .d-flex.flex-column.h-100
            input-location.mb-4(
                v-model="addressValue"
                @input="checkForPremise"
                :placeholder="$t('details.placeholder.address')" 
                required lg dropdown)       
                router-link.link-primary.mt-4(v-if="!$user.isLoggedIn" :to="{name: 'login'}" ) {{$t('base.sign_up_log_in')}}&nbsp;{{ $t('details.log_in_for_addresses') }}     
            box(:value="showDetails" :class="{'h-100': hasAddress}" slim)   
                input-textarea(
                    v-model="addressValue.sub_address"
                    validate="subAddress"
                    :maxHeight="150"
                    :max="255"
                    :placeholder="$t('details.placeholder.sub_address')"
                    live resize) {{$t('details.sub_address')}}             
            box(:value="hasAddress" :class="{'h-100': hasAddress}" slim)                
                specify-location(v-model="addressValue" @change="onLocationDrag" @next="setAddress" :loading.sync="loading" ref="specifyLocation" :height="330" :tooltip="$t('maps.move_pin')" full-address)      
    template(v-slot:footer)
        button.btn.btn-secondary.btn-block(@click="close ") {{ $t('base.cancel') }}
        button-loader.btn.btn-primary.btn-block.mt-0(@click="verifyDistance" :disabled="!hasAddress" :loading="loading") {{ $t("details.set_address") }}
       
</template>
